module.exports = __webpack_public_path__ + "static/media/aedc-icon.6870e6d8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svgs/aedc-icon.svg
// module id = 368
// module chunks = 25